import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import { TableBody, TableRow, TableCell, Box, Link, Typography } from '@mui/material';
import { StatusColor } from '../../../../components/StatusColor';
import { ROUTES, ROUTE_FOR_ASSETS, getRouteWithParam } from '../../../../constants/routes';
import { MoreActions } from '../MoreActions';
import { DISABLED_CONTROL_TOOLTIP } from '../../../../constants/variables';
import { Tooltip } from '@material-ui/core';

export const EnhancedBody = ({ rows, branches, permissions, userId }) => {
  const [tooltip, setTooltip] = useState(false);

  const wrapInTooltip = (component) => tooltip ? <Tooltip title={DISABLED_CONTROL_TOOLTIP} arrow data-testid="Tooltip">{component}</Tooltip> : component;

  return (
    <TableBody>
      {rows?.map((row) => {
        return (
          <TableRow key={row.id}>
            <TableCell>
              <Box component="p" sx={{ display: 'flex', alignItems: 'center' }}>
                <img width={36} height={36} src={`${ROUTE_FOR_ASSETS}${row.avatar}`} alt="avatar"/>
                {(permissions.retrieve || (!permissions.retrieve && userId === row.id)) ?
                  <Link
                    component={RouterLink}
                    to={userId === row.id ? ROUTES.PROFILE : getRouteWithParam(ROUTES.TEAM_PROFILE_PERSON, ':id', row.id)}
                    variant="body"
                    color="primary.main"
                    underline="hover"
                    sx={{ display: 'inline-block', marginLeft: '8px' }}
                  >
                    {row.firstName} {row.lastName}
                  </Link>
                  :
                  wrapInTooltip(
                    <Typography
                      sx={{ display: 'inline-block', marginLeft: '8px', fontSize: '1rem' }}
                      onClick={() => !permissions.retrieve && setTooltip(true)}
                      onMouseLeave={() => setTooltip(false)}
                    >
                      {row.firstName} {row.lastName}
                    </Typography>
                  )
                }
              </Box>
            </TableCell>
            <TableCell>{row.role.name}</TableCell>
            <TableCell>{branches?.find((branch) => branch.id === row.branch_id)?.label}</TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap' }} data-testid="PhoneNumber">{row.phone ? `+7 ${row.phone}` : ''}</TableCell>
            <TableCell>
              <Link
                variant="body"
                href={`mailto:${row.email}`}
                color="primary.main"
                underline="hover">
                {row.email}{' '}
              </Link>
            </TableCell>
            <TableCell>
              <StatusColor status={row.status} />
            </TableCell>
            <TableCell>
              <MoreActions
                status={row.status}
                id={row.id}
                clientName={`${row.firstName} ${row.lastName}`}
                permissions={permissions}
                userId={userId}
              />
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};

EnhancedBody.propTypes = {
  rows: PropTypes.array.isRequired,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  branches: PropTypes.array,
  permissions: PropTypes.object,
  userId: PropTypes.any,
};
